import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppConfigurationService } from './services/ipc-app-configuration.service';
import { AppConfigurationDirective } from './directives/ipc-app-configuration.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        AppConfigurationDirective
    ],
    declarations: [
        AppConfigurationDirective
    ],
    providers: [AppConfigurationService]
})
export class AppConfigurationModule {
    constructor() { }
}
